import { RootAppState } from 'store/configureStore'

export const quotationExpirationDateSelector = (state: RootAppState) => {
  return state.project.activeProject?.quotationExpiresAt
}
